import { FC, Fragment } from 'react';
// Components
import CaseContacts from 'app/components/CaseContacts';

const ContactsStepContent:FC = () => {
  return (
    <Fragment>
      <CaseContacts />
    </Fragment>
  );
};

export default ContactsStepContent;
